import hasPremiumSubscription from './has-premium-subscription';
import hasEcommerceSubscription from './has-ecommerce-subscription';

export default {
  hasPremiumSubscription,
  hasEcommerceSubscription,
};
